import { useEffect, useState } from "react";
import { Card, EmptyState, MetricCard, PageHeader } from "../components/ui";
import { dashboardService, type DashboardMetrics } from "../services/dashboard.service";
import { formatNumber } from "../lib/format";

export default function UsagePage() {
  const [metrics, setMetrics] = useState<DashboardMetrics | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dashboardService
      .summary()
      .then((summary) => setMetrics(summary.metrics))
      .catch(() => setMetrics(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader title="Uso" description="Consumo registrado nos últimos 30 dias." />

      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <MetricCard label="Execuções IA" value={formatNumber(metrics?.ai_runs_30d ?? 0)} loading={loading} />
        <MetricCard label="Falhas" value={formatNumber(metrics?.ai_runs_failed_30d ?? 0)} loading={loading} />
        <MetricCard label="Unidades" value={formatNumber(metrics?.usage_30d ?? 0)} loading={loading} />
        <MetricCard label="Deploys" value={formatNumber(metrics?.deployments_total ?? 0)} loading={loading} />
      </div>

      <Card title="Detalhamento por métrica">
        <EmptyState
          title="Sem registros de consumo"
          description="O detalhamento por métrica aparece quando as execuções de IA começarem a rodar."
        />
      </Card>
    </>
  );
}
